var Configuration = {

	init: function() {

		return $.getJSON('configuration.json', (function(json) {
			Language.setConfig(json['languages'], json['current-language']);
			Brand.setConfig(json['brands'], json['current-brand']);
		}).bind(this)).fail(function() {
			console.error('Error loading configuration.json');
		});
	},

	load: function() {
		return $.when(this.init());
	}
}